module.exports = [{
      plugin: require('C:/Users/user/dev/face-api.js/face-api.js-github.io/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-109709749-3","head":false,"anonymize":true,"respectDNT":true},
    }]
